{
  "library": {
    "categoryView": "Kategori",
    "filter": {
      "owner": "Ägare",
      "tags": "Taggar",
      "tiers": "Nivåer"
    },
    "header": "Bibliotek",

    "noDocumentsFound": "Inga dokument hittades",
    "filterByTitlePlaceholder": "Filtrera på titel...",
    "columns": "Kolumner",
    "noResults": "Inga resultat.",
    "filters": {
      "before": "Före",
      "after": "Efter",
      "selectedCount": "{{count}} valda",
      "invalidDateRange": "Efter-datum måste vara före eller samma som Före-datum",
      "isBefore": "är före",
      "isAfter": "är efter",
      "isBetween": "är mellan",
      "equals": "är",
      "includes": "är en av",
      "notSet": "ej satt",
      "nullLabel": {
        "adoptedAt": "Ej beslutad",
        "reviewFrom": "Ingen granskning från",
        "reviewTo": "Ingen granskning till"
      }
    },
    "onboardDocuments": {
      "header": "Onboarda dokument",
      "subtitle": "Följ guiden för att onboarda dina dokument till North House",
      "steps": {
        "createDrafts": {
          "title": "Skapa utkast",
          "description": "Ladda upp era dokument och placera varje i kategori och nivå",
          "cardTitle": "Ange titel, nivå och kategori",
          "cardDescription": "Konfigurera grundläggande metadata för varje uppladdat dokument. Detta kan ändras senare.",
          "columns": {
            "title": "Titel",
            "tier": "Nivå",
            "category": "Kategori"
          },
          "requiredField": "Obligatoriskt fält",
          "create": "Skapa dokument",
          "created": "Skapat",
          "createdLabel": "{{createdCount}} / {{totalCount}} skapade",
          "createCount": "Skapa {{count}} valda",
          "next": "Nästa",
          "clickOrDrag": "Klicka eller dra filer för att ladda upp",
          "addMore": "Lägg till fler filer",
          "duplicateFiles": "Redan uppladdade filer hoppades över",
          "unsupportedType": "\"{{name}}\" har en filtyp som inte stöds",
          "fileTooLarge": "\"{{name}}\" överskrider storleksgränsen på 50 MB",
          "clearSelected": "Ta bort {{count}} markerade",
          "duplicateWarning": "Ett icke-arkiverat dokument med denna titel finns redan i kategorin.",
          "failedToCreate": "Kunde inte skapas.",
          "removeRow": "Ta bort rad",
          "toasts": {
            "createdSome": "Skapade {{count}} dokument",
            "failedSome": "{{count}} dokument kunde inte skapas"
          }
        },
        "configureAndPublish": {
          "title": "Granska och slutför",
          "description": "Publicera dokument och slutför onboardingen",
          "cardTitle": "Granska dokumentens uppgifter",
          "cardDescription": "Ändra metadata och publicera dokumenten.",
          "columns": {
            "title": "Titel",
            "category": "Kategori",
            "owner": "Ägare",
            "publisher": "Utgivare",
            "status": "Status"
          },
          "completeOnboarding": "Slutför onboarding",
          "goToLibrary": "Gå till biblioteket",
          "onboardMore": "Onboarda fler dokument",
          "toasts": {
            "published": "Publicerade {{count}} dokument",
            "failedPublish": "Kunde inte publicera {{count}} dokument"
          }
        }
      }
    }
  }
}
